module.exports = __webpack_public_path__ + "img/icon_map_11_on_010.4f5e3546.png";